import { Select } from '@sparemin/blockhead';
import { OptionItem } from 'components/OptionsList/types';
import { MAX_CHARACTER_PER_LINE_VALUES } from './constants';
import * as S from './styles';

export type MaxCharactersPerLineControlProps = Pick<
  OptionItem,
  'label' | 'isDisabled'
> & {
  value?: number;
  onChange: (value: number) => void;
};

const MaxCharactersPerLineControl: React.FC<
  MaxCharactersPerLineControlProps
> = ({ label, isDisabled, value, onChange }) => {
  return (
    <S.MaxCharactersSelector
      {...{ label, isDisabled }}
      layout="horizontal"
      triggerWidth="auto"
      labelGap="auto"
      selectedKey={!value ? null : value?.toString()}
      onSelectionChange={(nextValue) => {
        onChange?.(Number(nextValue));
      }}
      $isDisabled={isDisabled}
    >
      {MAX_CHARACTER_PER_LINE_VALUES.map((option) => (
        <Select.Option key={option.toString()} textValue={option.toString()}>
          <S.CustomOptionSelectValue>{option}</S.CustomOptionSelectValue>
        </Select.Option>
      ))}
    </S.MaxCharactersSelector>
  );
};

export default MaxCharactersPerLineControl;
